// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../public/images/ind.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../public/images/calender_icon.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*--------------Mixins------------------*/
.ml-0 {
  margin-left: 0px !important;
}

.mr-0 {
  margin-right: 0px !important;
}

.mt-0 {
  margin-top: 0px !important;
}

.mb-0 {
  margin-bottom: 0px !important;
}

.mx-0 {
  margin-left: 0px !important;
  margin-right: 0px !important;
}

.my-0 {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.ml-1 {
  margin-left: 4px !important;
}

.mr-1 {
  margin-right: 4px !important;
}

.mt-1 {
  margin-top: 4px !important;
}

.mb-1 {
  margin-bottom: 4px !important;
}

.mx-1 {
  margin-left: 4px !important;
  margin-right: 4px !important;
}

.my-1 {
  margin-top: 4px !important;
  margin-bottom: 4px !important;
}

.ml-2 {
  margin-left: 8px !important;
}

.mr-2 {
  margin-right: 8px !important;
}

.mt-2 {
  margin-top: 8px !important;
}

.mb-2 {
  margin-bottom: 8px !important;
}

.mx-2 {
  margin-left: 8px !important;
  margin-right: 8px !important;
}

.my-2 {
  margin-top: 8px !important;
  margin-bottom: 8px !important;
}

.ml-3 {
  margin-left: 12px !important;
}

.mr-3 {
  margin-right: 12px !important;
}

.mt-3 {
  margin-top: 12px !important;
}

.mb-3 {
  margin-bottom: 12px !important;
}

.mx-3 {
  margin-left: 12px !important;
  margin-right: 12px !important;
}

.my-3 {
  margin-top: 12px !important;
  margin-bottom: 12px !important;
}

.ml-4 {
  margin-left: 16px !important;
}

.mr-4 {
  margin-right: 16px !important;
}

.mt-4 {
  margin-top: 16px !important;
}

.mb-4 {
  margin-bottom: 16px !important;
}

.mx-4 {
  margin-left: 16px !important;
  margin-right: 16px !important;
}

.my-4 {
  margin-top: 16px !important;
  margin-bottom: 16px !important;
}

.ml-5 {
  margin-left: 20px !important;
}

.mr-5 {
  margin-right: 20px !important;
}

.mt-5 {
  margin-top: 20px !important;
}

.mb-5 {
  margin-bottom: 20px !important;
}

.mx-5 {
  margin-left: 20px !important;
  margin-right: 20px !important;
}

.my-5 {
  margin-top: 20px !important;
  margin-bottom: 20px !important;
}

.ml-6 {
  margin-left: 24px !important;
}

.mr-6 {
  margin-right: 24px !important;
}

.mt-6 {
  margin-top: 24px !important;
}

.mb-6 {
  margin-bottom: 24px !important;
}

.mx-6 {
  margin-left: 24px !important;
  margin-right: 24px !important;
}

.my-6 {
  margin-top: 24px !important;
  margin-bottom: 24px !important;
}

.ml-7 {
  margin-left: 28px !important;
}

.mr-7 {
  margin-right: 28px !important;
}

.mt-7 {
  margin-top: 28px !important;
}

.mb-7 {
  margin-bottom: 28px !important;
}

.mx-7 {
  margin-left: 28px !important;
  margin-right: 28px !important;
}

.my-7 {
  margin-top: 28px !important;
  margin-bottom: 28px !important;
}

.ml-8 {
  margin-left: 32px !important;
}

.mr-8 {
  margin-right: 32px !important;
}

.mt-8 {
  margin-top: 32px !important;
}

.mb-8 {
  margin-bottom: 32px !important;
}

.mx-8 {
  margin-left: 32px !important;
  margin-right: 32px !important;
}

.my-8 {
  margin-top: 32px !important;
  margin-bottom: 32px !important;
}

.ml-9 {
  margin-left: 36px !important;
}

.mr-9 {
  margin-right: 36px !important;
}

.mt-9 {
  margin-top: 36px !important;
}

.mb-9 {
  margin-bottom: 36px !important;
}

.mx-9 {
  margin-left: 36px !important;
  margin-right: 36px !important;
}

.my-9 {
  margin-top: 36px !important;
  margin-bottom: 36px !important;
}

.ml-10 {
  margin-left: 40px !important;
}

.mr-10 {
  margin-right: 40px !important;
}

.mt-10 {
  margin-top: 40px !important;
}

.mb-10 {
  margin-bottom: 40px !important;
}

.mx-10 {
  margin-left: 40px !important;
  margin-right: 40px !important;
}

.my-10 {
  margin-top: 40px !important;
  margin-bottom: 40px !important;
}

.ml-11 {
  margin-left: 44px !important;
}

.mr-11 {
  margin-right: 44px !important;
}

.mt-11 {
  margin-top: 44px !important;
}

.mb-11 {
  margin-bottom: 44px !important;
}

.mx-11 {
  margin-left: 44px !important;
  margin-right: 44px !important;
}

.my-11 {
  margin-top: 44px !important;
  margin-bottom: 44px !important;
}

.ml-12 {
  margin-left: 48px !important;
}

.mr-12 {
  margin-right: 48px !important;
}

.mt-12 {
  margin-top: 48px !important;
}

.mb-12 {
  margin-bottom: 48px !important;
}

.mx-12 {
  margin-left: 48px !important;
  margin-right: 48px !important;
}

.my-12 {
  margin-top: 48px !important;
  margin-bottom: 48px !important;
}

.ml-13 {
  margin-left: 52px !important;
}

.mr-13 {
  margin-right: 52px !important;
}

.mt-13 {
  margin-top: 52px !important;
}

.mb-13 {
  margin-bottom: 52px !important;
}

.mx-13 {
  margin-left: 52px !important;
  margin-right: 52px !important;
}

.my-13 {
  margin-top: 52px !important;
  margin-bottom: 52px !important;
}

.ml-14 {
  margin-left: 56px !important;
}

.mr-14 {
  margin-right: 56px !important;
}

.mt-14 {
  margin-top: 56px !important;
}

.mb-14 {
  margin-bottom: 56px !important;
}

.mx-14 {
  margin-left: 56px !important;
  margin-right: 56px !important;
}

.my-14 {
  margin-top: 56px !important;
  margin-bottom: 56px !important;
}

.ml-15 {
  margin-left: 60px !important;
}

.mr-15 {
  margin-right: 60px !important;
}

.mt-15 {
  margin-top: 60px !important;
}

.mb-15 {
  margin-bottom: 60px !important;
}

.mx-15 {
  margin-left: 60px !important;
  margin-right: 60px !important;
}

.my-15 {
  margin-top: 60px !important;
  margin-bottom: 60px !important;
}

.ml-16 {
  margin-left: 64px !important;
}

.mr-16 {
  margin-right: 64px !important;
}

.mt-16 {
  margin-top: 64px !important;
}

.mb-16 {
  margin-bottom: 64px !important;
}

.mx-16 {
  margin-left: 64px !important;
  margin-right: 64px !important;
}

.my-16 {
  margin-top: 64px !important;
  margin-bottom: 64px !important;
}

.ml-17 {
  margin-left: 68px !important;
}

.mr-17 {
  margin-right: 68px !important;
}

.mt-17 {
  margin-top: 68px !important;
}

.mb-17 {
  margin-bottom: 68px !important;
}

.mx-17 {
  margin-left: 68px !important;
  margin-right: 68px !important;
}

.my-17 {
  margin-top: 68px !important;
  margin-bottom: 68px !important;
}

.ml-18 {
  margin-left: 72px !important;
}

.mr-18 {
  margin-right: 72px !important;
}

.mt-18 {
  margin-top: 72px !important;
}

.mb-18 {
  margin-bottom: 72px !important;
}

.mx-18 {
  margin-left: 72px !important;
  margin-right: 72px !important;
}

.my-18 {
  margin-top: 72px !important;
  margin-bottom: 72px !important;
}

.ml-19 {
  margin-left: 76px !important;
}

.mr-19 {
  margin-right: 76px !important;
}

.mt-19 {
  margin-top: 76px !important;
}

.mb-19 {
  margin-bottom: 76px !important;
}

.mx-19 {
  margin-left: 76px !important;
  margin-right: 76px !important;
}

.my-19 {
  margin-top: 76px !important;
  margin-bottom: 76px !important;
}

.pl-0 {
  padding-left: 0px !important;
}

.pr-0 {
  padding-right: 0px !important;
}

.pt-0 {
  padding-top: 0px !important;
}

.pb-0 {
  padding-bottom: 0px !important;
}

.px-0 {
  padding-left: 0px !important;
  padding-right: 0px !important;
}

.py-0 {
  padding-top: 0px !important;
  padding-bottom: 0px !important;
}

.pl-1 {
  padding-left: 4px !important;
}

.pr-1 {
  padding-right: 4px !important;
}

.pt-1 {
  padding-top: 4px !important;
}

.pb-1 {
  padding-bottom: 4px !important;
}

.px-1 {
  padding-left: 4px !important;
  padding-right: 4px !important;
}

.py-1 {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}

.pl-2 {
  padding-left: 8px !important;
}

.pr-2 {
  padding-right: 8px !important;
}

.pt-2 {
  padding-top: 8px !important;
}

.pb-2 {
  padding-bottom: 8px !important;
}

.px-2 {
  padding-left: 8px !important;
  padding-right: 8px !important;
}

.py-2 {
  padding-top: 8px !important;
  padding-bottom: 8px !important;
}

.pl-3 {
  padding-left: 12px !important;
}

.pr-3 {
  padding-right: 12px !important;
}

.pt-3 {
  padding-top: 12px !important;
}

.pb-3 {
  padding-bottom: 12px !important;
}

.px-3 {
  padding-left: 12px !important;
  padding-right: 12px !important;
}

.py-3 {
  padding-top: 12px !important;
  padding-bottom: 12px !important;
}

.pl-4 {
  padding-left: 16px !important;
}

.pr-4 {
  padding-right: 16px !important;
}

.pt-4 {
  padding-top: 16px !important;
}

.pb-4 {
  padding-bottom: 16px !important;
}

.px-4 {
  padding-left: 16px !important;
  padding-right: 16px !important;
}

.py-4 {
  padding-top: 16px !important;
  padding-bottom: 16px !important;
}

.pl-5 {
  padding-left: 20px !important;
}

.pr-5 {
  padding-right: 20px !important;
}

.pt-5 {
  padding-top: 20px !important;
}

.pb-5 {
  padding-bottom: 20px !important;
}

.px-5 {
  padding-left: 20px !important;
  padding-right: 20px !important;
}

.py-5 {
  padding-top: 20px !important;
  padding-bottom: 20px !important;
}

.pl-6 {
  padding-left: 24px !important;
}

.pr-6 {
  padding-right: 24px !important;
}

.pt-6 {
  padding-top: 24px !important;
}

.pb-6 {
  padding-bottom: 24px !important;
}

.px-6 {
  padding-left: 24px !important;
  padding-right: 24px !important;
}

.py-6 {
  padding-top: 24px !important;
  padding-bottom: 24px !important;
}

.pl-7 {
  padding-left: 28px !important;
}

.pr-7 {
  padding-right: 28px !important;
}

.pt-7 {
  padding-top: 28px !important;
}

.pb-7 {
  padding-bottom: 28px !important;
}

.px-7 {
  padding-left: 28px !important;
  padding-right: 28px !important;
}

.py-7 {
  padding-top: 28px !important;
  padding-bottom: 28px !important;
}

.pl-8 {
  padding-left: 32px !important;
}

.pr-8 {
  padding-right: 32px !important;
}

.pt-8 {
  padding-top: 32px !important;
}

.pb-8 {
  padding-bottom: 32px !important;
}

.px-8 {
  padding-left: 32px !important;
  padding-right: 32px !important;
}

.py-8 {
  padding-top: 32px !important;
  padding-bottom: 32px !important;
}

.pl-9 {
  padding-left: 36px !important;
}

.pr-9 {
  padding-right: 36px !important;
}

.pt-9 {
  padding-top: 36px !important;
}

.pb-9 {
  padding-bottom: 36px !important;
}

.px-9 {
  padding-left: 36px !important;
  padding-right: 36px !important;
}

.py-9 {
  padding-top: 36px !important;
  padding-bottom: 36px !important;
}

.pl-10 {
  padding-left: 40px !important;
}

.pr-10 {
  padding-right: 40px !important;
}

.pt-10 {
  padding-top: 40px !important;
}

.pb-10 {
  padding-bottom: 40px !important;
}

.px-10 {
  padding-left: 40px !important;
  padding-right: 40px !important;
}

.py-10 {
  padding-top: 40px !important;
  padding-bottom: 40px !important;
}

.pl-11 {
  padding-left: 44px !important;
}

.pr-11 {
  padding-right: 44px !important;
}

.pt-11 {
  padding-top: 44px !important;
}

.pb-11 {
  padding-bottom: 44px !important;
}

.px-11 {
  padding-left: 44px !important;
  padding-right: 44px !important;
}

.py-11 {
  padding-top: 44px !important;
  padding-bottom: 44px !important;
}

.pl-12 {
  padding-left: 48px !important;
}

.pr-12 {
  padding-right: 48px !important;
}

.pt-12 {
  padding-top: 48px !important;
}

.pb-12 {
  padding-bottom: 48px !important;
}

.px-12 {
  padding-left: 48px !important;
  padding-right: 48px !important;
}

.py-12 {
  padding-top: 48px !important;
  padding-bottom: 48px !important;
}

.pl-13 {
  padding-left: 52px !important;
}

.pr-13 {
  padding-right: 52px !important;
}

.pt-13 {
  padding-top: 52px !important;
}

.pb-13 {
  padding-bottom: 52px !important;
}

.px-13 {
  padding-left: 52px !important;
  padding-right: 52px !important;
}

.py-13 {
  padding-top: 52px !important;
  padding-bottom: 52px !important;
}

.pl-14 {
  padding-left: 56px !important;
}

.pr-14 {
  padding-right: 56px !important;
}

.pt-14 {
  padding-top: 56px !important;
}

.pb-14 {
  padding-bottom: 56px !important;
}

.px-14 {
  padding-left: 56px !important;
  padding-right: 56px !important;
}

.py-14 {
  padding-top: 56px !important;
  padding-bottom: 56px !important;
}

.pl-15 {
  padding-left: 60px !important;
}

.pr-15 {
  padding-right: 60px !important;
}

.pt-15 {
  padding-top: 60px !important;
}

.pb-15 {
  padding-bottom: 60px !important;
}

.px-15 {
  padding-left: 60px !important;
  padding-right: 60px !important;
}

.py-15 {
  padding-top: 60px !important;
  padding-bottom: 60px !important;
}

.pl-16 {
  padding-left: 64px !important;
}

.pr-16 {
  padding-right: 64px !important;
}

.pt-16 {
  padding-top: 64px !important;
}

.pb-16 {
  padding-bottom: 64px !important;
}

.px-16 {
  padding-left: 64px !important;
  padding-right: 64px !important;
}

.py-16 {
  padding-top: 64px !important;
  padding-bottom: 64px !important;
}

.pl-17 {
  padding-left: 68px !important;
}

.pr-17 {
  padding-right: 68px !important;
}

.pt-17 {
  padding-top: 68px !important;
}

.pb-17 {
  padding-bottom: 68px !important;
}

.px-17 {
  padding-left: 68px !important;
  padding-right: 68px !important;
}

.py-17 {
  padding-top: 68px !important;
  padding-bottom: 68px !important;
}

.pl-18 {
  padding-left: 72px !important;
}

.pr-18 {
  padding-right: 72px !important;
}

.pt-18 {
  padding-top: 72px !important;
}

.pb-18 {
  padding-bottom: 72px !important;
}

.px-18 {
  padding-left: 72px !important;
  padding-right: 72px !important;
}

.py-18 {
  padding-top: 72px !important;
  padding-bottom: 72px !important;
}

.pl-19 {
  padding-left: 76px !important;
}

.pr-19 {
  padding-right: 76px !important;
}

.pt-19 {
  padding-top: 76px !important;
}

.pb-19 {
  padding-bottom: 76px !important;
}

.px-19 {
  padding-left: 76px !important;
  padding-right: 76px !important;
}

.py-19 {
  padding-top: 76px !important;
  padding-bottom: 76px !important;
}

.inputField {
  position: relative;
  width: 100%;
}
.inputField label,
.inputField input {
  font-weight: 400;
  letter-spacing: 0px;
  font-size: 0.8125rem;
  font-family: "Poppins", sans-serif;
  color: #000000;
}
.inputField label {
  transform: translate(14px, 10px) scale(1);
  top: 3px;
}
.inputField svg {
  display: none;
}
.inputField.vehicleNumberField:before {
  position: absolute;
  top: 0;
  left: 0;
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat 0 0/30px;
  width: 40px;
  height: 44px;
  border-radius: 5px 0px 0px 5px;
  z-index: 4;
}
.inputField.vehicleNumberField input {
  padding: 10px 12px 11px 42px;
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
}
.inputField.datepicker:before {
  position: absolute;
  top: calc(50% - 6px);
  right: 12px;
  content: "";
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat 0 0/13px;
  width: 13px;
  height: 13px;
  z-index: 4;
}
.inputField.datepicker .MuiTextField-root {
  width: 100%;
}
.inputField.datepicker fieldset {
  border-color: rgba(0, 0, 0, 0.2) !important;
}
.inputField.datepicker label {
  color: #000000;
}
.inputField.nativeSelect {
  position: relative;
}
.inputField.nativeSelect:before {
  position: absolute;
  top: 17px;
  right: 10px;
  content: "";
  border: solid #000000;
  border-width: 0px 0px 1.4px 1.4px;
  transform: rotate(-45deg);
  transition: all 0.3s ease;
  transform-origin: center;
  height: 6px;
  width: 6px;
  z-index: 1;
}
.inputField.nativeSelect .MuiInputLabel-shrink {
  background: white;
  border-radius: 8px;
  padding-left: 4px;
  padding-right: 12px;
  transform: translate(8px, -9px) scale(0.75);
}
.inputField.nativeSelect .MuiInputBase-root {
  margin-top: 0;
  height: 44px;
}
.inputField.nativeSelect .MuiInputBase-root:before {
  display: none;
}
.inputField.nativeSelect .MuiInputBase-root:after {
  display: none;
}
.inputField.nativeSelect .MuiInputBase-root .MuiNativeSelect-select {
  padding: 11.7px 24px 11.6px 10px;
  font-size: 0.8125rem;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  font-family: "poppins", "sans-serif";
}
.inputField.nativeSelect .MuiInputBase-root .MuiNativeSelect-select:focus {
  border-color: #1E2E5F !important;
}
.inputField.nativeSelect .MuiInputBase-root .MuiNativeSelect-select :nth-child(1) {
  display: none;
}
.inputField .infoMessage {
  background: #ffffff;
  border-radius: 20px;
  position: absolute;
  top: 9px;
  left: -7px;
  height: 16px;
  width: 16px;
  z-index: 9;
}
.inputField .infoMessage svg {
  color: #000;
  opacity: 0.6;
  display: inherit;
  font-size: 0.875rem;
  margin-top: 1px;
  margin-left: 1px;
}
.inputField input {
  border-radius: 8px;
  background: #ffffff;
  padding: 12px 12px;
}
.inputField .MuiInputBase-root {
  background: #ffffff;
  border-radius: 8px;
  height: 44px;
}
.inputField .MuiInputBase-multiline {
  height: auto;
  font-family: "poppins", "sans-serif";
}
.inputField .MuiAutocomplete-root:before {
  position: absolute;
  top: 17px;
  right: 14px;
  content: "";
  border: solid #000000;
  border-width: 0px 0px 1.4px 1.4px;
  transform: rotate(-45deg);
  transition: all 0.3s ease;
  transform-origin: center;
  height: 6px;
  width: 6px;
  z-index: 1;
}
.inputField .MuiAutocomplete-root .MuiAutocomplete-inputRoot {
  border-radius: 8px;
  padding: 0px 0px 0px 8px;
  height: 44px;
}
.inputField .MuiAutocomplete-root .MuiAutocomplete-clearIndicator {
  background: #fff;
  height: 18px;
  width: 18px;
  border: 1px solid #ccc;
}
.inputField .MuiAutocomplete-root .MuiAutocomplete-clearIndicator svg {
  display: block;
  height: 12px;
  color: #1E2E5F;
}
.inputField .MuiAutocomplete-endAdornment {
  display: none;
}
.inputField .MuiAutocomplete-hasClearIcon .MuiFormControl-root .MuiOutlinedInput-root {
  height: 44px;
  border-radius: 8px;
  padding: 8px 0px 7px 8px;
}
.inputField .MuiAutocomplete-hasClearIcon .MuiFormControl-root .MuiOutlinedInput-root .MuiButtonBase-root {
  height: 20px;
}
.inputField .MuiAutocomplete-hasClearIcon .MuiFormControl-root .MuiOutlinedInput-root .MuiButtonBase-root.MuiAutocomplete-clearIndicator {
  display: none;
}
.inputField .MuiAutocomplete-hasClearIcon .MuiFormControl-root .MuiOutlinedInput-root .MuiButtonBase-root .MuiChip-label {
  font-size: 0.625rem;
}
.inputField .MuiAutocomplete-hasClearIcon .MuiFormControl-root .MuiOutlinedInput-root .MuiButtonBase-root#ArrowDropDownIcon {
  display: none !important;
}
.inputField .MuiAutocomplete-hasClearIcon .MuiFormControl-root .MuiOutlinedInput-root .MuiButtonBase-root svg {
  display: block;
}
.inputField .MuiAutocomplete-hasClearIcon .MuiFormControl-root .MuiOutlinedInput-root .MuiButtonBase-root .MuiTouchRipple-root {
  display: none;
}
.inputField .MuiAutocomplete-hasClearIcon .MuiFormControl-root .MuiOutlinedInput-root .MuiButtonBase-root .MuiChip-deleteIcon {
  color: rgba(0, 0, 0, 0.26);
  font-size: 1.125rem;
  cursor: pointer;
  margin: 0px 2px 0 -6px;
}
.inputField .MuiAutocomplete-hasClearIcon .MuiFormControl-root .MuiOutlinedInput-root .MuiAutocomplete-input {
  min-width: 0px !important;
  padding: 4.5px 4px 7.5px 5px;
}
.inputField .MuiAutocomplete-popper {
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.2) !important;
  border-radius: 0px 0px 8px 8px;
}
.inputField .MuiAutocomplete-popper .MuiAutocomplete-paper {
  border-radius: 0px 0px 8px 8px;
}
.inputField .MuiAutocomplete-popper ul {
  max-height: 240px;
  overflow-y: auto;
}
.inputField .MuiAutocomplete-popper ul li {
  text-align: left;
}
.inputField .MuiAutocomplete-popper .MuiAutocomplete-option {
  font-size: 0.8125rem;
  line-height: 18px;
  min-height: 32px;
}
.inputField .MuiInputLabel-shrink {
  color: #1E2E5F !important;
  transform: translate(14px, -9px) scale(0.75);
}
.inputField .MuiSelect-select {
  text-align: left;
  padding: 14px 12px;
  font-size: 0.8125rem;
  border-radius: 8px;
  font-family: "Poppins", sans-serif;
  padding-right: 16px !important;
}
.inputField .MuiSelect-select:before {
  position: absolute;
  top: 20px;
  right: 10px;
  content: "";
  border: solid #000000;
  border-width: 0px 0px 1.4px 1.4px;
  transform: rotate(-45deg);
  transform-origin: left center;
  height: 6px;
  width: 6px;
}
.inputField .Mui-focused .MuiOutlinedInput-notchedOutline {
  border-color: #000 !important;
}
.inputField fieldset {
  border-color: rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  border-width: 1px !important;
  font-weight: 500;
}
.inputField .error {
  color: #BE2532;
  font-size: 0.6875rem;
  text-align: right;
  position: absolute;
  right: 0px;
  bottom: -16px;
}
.inputField .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.css-1h51icj-MuiAutocomplete-root .MuiOutlinedInput-root {
  padding-right: 40px !important;
}

.MuiMenu-paper {
  max-height: 200px !important;
}
.MuiMenu-paper .MuiMenu-list .MuiMenuItem-root {
  font-size: 0.875rem;
  font-family: "Poppins", sans-serif !important;
}`, "",{"version":3,"sources":["webpack://./src/SCSS/Mixins.scss","webpack://./src/Components/InputFields/FieldTypes.scss"],"names":[],"mappings":"AAWA,yCAAA;AAoDI;EACI,2BAAA;AC7DR;;ADgEI;EACI,4BAAA;AC7DR;;ADgEI;EACI,0BAAA;AC7DR;;ADgEI;EACI,6BAAA;AC7DR;;ADgEI;EACI,2BAAA;EACA,4BAAA;AC7DR;;ADgEI;EACI,0BAAA;EACA,6BAAA;AC7DR;;ADsCI;EACI,2BAAA;ACnCR;;ADsCI;EACI,4BAAA;ACnCR;;ADsCI;EACI,0BAAA;ACnCR;;ADsCI;EACI,6BAAA;ACnCR;;ADsCI;EACI,2BAAA;EACA,4BAAA;ACnCR;;ADsCI;EACI,0BAAA;EACA,6BAAA;ACnCR;;ADYI;EACI,2BAAA;ACTR;;ADYI;EACI,4BAAA;ACTR;;ADYI;EACI,0BAAA;ACTR;;ADYI;EACI,6BAAA;ACTR;;ADYI;EACI,2BAAA;EACA,4BAAA;ACTR;;ADYI;EACI,0BAAA;EACA,6BAAA;ACTR;;ADdI;EACI,4BAAA;ACiBR;;ADdI;EACI,6BAAA;ACiBR;;ADdI;EACI,2BAAA;ACiBR;;ADdI;EACI,8BAAA;ACiBR;;ADdI;EACI,4BAAA;EACA,6BAAA;ACiBR;;ADdI;EACI,2BAAA;EACA,8BAAA;ACiBR;;ADxCI;EACI,4BAAA;AC2CR;;ADxCI;EACI,6BAAA;AC2CR;;ADxCI;EACI,2BAAA;AC2CR;;ADxCI;EACI,8BAAA;AC2CR;;ADxCI;EACI,4BAAA;EACA,6BAAA;AC2CR;;ADxCI;EACI,2BAAA;EACA,8BAAA;AC2CR;;ADlEI;EACI,4BAAA;ACqER;;ADlEI;EACI,6BAAA;ACqER;;ADlEI;EACI,2BAAA;ACqER;;ADlEI;EACI,8BAAA;ACqER;;ADlEI;EACI,4BAAA;EACA,6BAAA;ACqER;;ADlEI;EACI,2BAAA;EACA,8BAAA;ACqER;;AD5FI;EACI,4BAAA;AC+FR;;AD5FI;EACI,6BAAA;AC+FR;;AD5FI;EACI,2BAAA;AC+FR;;AD5FI;EACI,8BAAA;AC+FR;;AD5FI;EACI,4BAAA;EACA,6BAAA;AC+FR;;AD5FI;EACI,2BAAA;EACA,8BAAA;AC+FR;;ADtHI;EACI,4BAAA;ACyHR;;ADtHI;EACI,6BAAA;ACyHR;;ADtHI;EACI,2BAAA;ACyHR;;ADtHI;EACI,8BAAA;ACyHR;;ADtHI;EACI,4BAAA;EACA,6BAAA;ACyHR;;ADtHI;EACI,2BAAA;EACA,8BAAA;ACyHR;;ADhJI;EACI,4BAAA;ACmJR;;ADhJI;EACI,6BAAA;ACmJR;;ADhJI;EACI,2BAAA;ACmJR;;ADhJI;EACI,8BAAA;ACmJR;;ADhJI;EACI,4BAAA;EACA,6BAAA;ACmJR;;ADhJI;EACI,2BAAA;EACA,8BAAA;ACmJR;;AD1KI;EACI,4BAAA;AC6KR;;AD1KI;EACI,6BAAA;AC6KR;;AD1KI;EACI,2BAAA;AC6KR;;AD1KI;EACI,8BAAA;AC6KR;;AD1KI;EACI,4BAAA;EACA,6BAAA;AC6KR;;AD1KI;EACI,2BAAA;EACA,8BAAA;AC6KR;;ADpMI;EACI,4BAAA;ACuMR;;ADpMI;EACI,6BAAA;ACuMR;;ADpMI;EACI,2BAAA;ACuMR;;ADpMI;EACI,8BAAA;ACuMR;;ADpMI;EACI,4BAAA;EACA,6BAAA;ACuMR;;ADpMI;EACI,2BAAA;EACA,8BAAA;ACuMR;;AD9NI;EACI,4BAAA;ACiOR;;AD9NI;EACI,6BAAA;ACiOR;;AD9NI;EACI,2BAAA;ACiOR;;AD9NI;EACI,8BAAA;ACiOR;;AD9NI;EACI,4BAAA;EACA,6BAAA;ACiOR;;AD9NI;EACI,2BAAA;EACA,8BAAA;ACiOR;;ADxPI;EACI,4BAAA;AC2PR;;ADxPI;EACI,6BAAA;AC2PR;;ADxPI;EACI,2BAAA;AC2PR;;ADxPI;EACI,8BAAA;AC2PR;;ADxPI;EACI,4BAAA;EACA,6BAAA;AC2PR;;ADxPI;EACI,2BAAA;EACA,8BAAA;AC2PR;;ADlRI;EACI,4BAAA;ACqRR;;ADlRI;EACI,6BAAA;ACqRR;;ADlRI;EACI,2BAAA;ACqRR;;ADlRI;EACI,8BAAA;ACqRR;;ADlRI;EACI,4BAAA;EACA,6BAAA;ACqRR;;ADlRI;EACI,2BAAA;EACA,8BAAA;ACqRR;;AD5SI;EACI,4BAAA;AC+SR;;AD5SI;EACI,6BAAA;AC+SR;;AD5SI;EACI,2BAAA;AC+SR;;AD5SI;EACI,8BAAA;AC+SR;;AD5SI;EACI,4BAAA;EACA,6BAAA;AC+SR;;AD5SI;EACI,2BAAA;EACA,8BAAA;AC+SR;;ADtUI;EACI,4BAAA;ACyUR;;ADtUI;EACI,6BAAA;ACyUR;;ADtUI;EACI,2BAAA;ACyUR;;ADtUI;EACI,8BAAA;ACyUR;;ADtUI;EACI,4BAAA;EACA,6BAAA;ACyUR;;ADtUI;EACI,2BAAA;EACA,8BAAA;ACyUR;;ADhWI;EACI,4BAAA;ACmWR;;ADhWI;EACI,6BAAA;ACmWR;;ADhWI;EACI,2BAAA;ACmWR;;ADhWI;EACI,8BAAA;ACmWR;;ADhWI;EACI,4BAAA;EACA,6BAAA;ACmWR;;ADhWI;EACI,2BAAA;EACA,8BAAA;ACmWR;;AD1XI;EACI,4BAAA;AC6XR;;AD1XI;EACI,6BAAA;AC6XR;;AD1XI;EACI,2BAAA;AC6XR;;AD1XI;EACI,8BAAA;AC6XR;;AD1XI;EACI,4BAAA;EACA,6BAAA;AC6XR;;AD1XI;EACI,2BAAA;EACA,8BAAA;AC6XR;;ADpZI;EACI,4BAAA;ACuZR;;ADpZI;EACI,6BAAA;ACuZR;;ADpZI;EACI,2BAAA;ACuZR;;ADpZI;EACI,8BAAA;ACuZR;;ADpZI;EACI,4BAAA;EACA,6BAAA;ACuZR;;ADpZI;EACI,2BAAA;EACA,8BAAA;ACuZR;;AD9aI;EACI,4BAAA;ACibR;;AD9aI;EACI,6BAAA;ACibR;;AD9aI;EACI,2BAAA;ACibR;;AD9aI;EACI,8BAAA;ACibR;;AD9aI;EACI,4BAAA;EACA,6BAAA;ACibR;;AD9aI;EACI,2BAAA;EACA,8BAAA;ACibR;;AD3aI;EACI,4BAAA;AC8aR;;AD3aI;EACI,6BAAA;AC8aR;;AD3aI;EACI,2BAAA;AC8aR;;AD3aI;EACI,8BAAA;AC8aR;;AD3aI;EACI,4BAAA;EACA,6BAAA;AC8aR;;AD3aI;EACI,2BAAA;EACA,8BAAA;AC8aR;;ADrcI;EACI,4BAAA;ACwcR;;ADrcI;EACI,6BAAA;ACwcR;;ADrcI;EACI,2BAAA;ACwcR;;ADrcI;EACI,8BAAA;ACwcR;;ADrcI;EACI,4BAAA;EACA,6BAAA;ACwcR;;ADrcI;EACI,2BAAA;EACA,8BAAA;ACwcR;;AD/dI;EACI,4BAAA;ACkeR;;AD/dI;EACI,6BAAA;ACkeR;;AD/dI;EACI,2BAAA;ACkeR;;AD/dI;EACI,8BAAA;ACkeR;;AD/dI;EACI,4BAAA;EACA,6BAAA;ACkeR;;AD/dI;EACI,2BAAA;EACA,8BAAA;ACkeR;;ADzfI;EACI,6BAAA;AC4fR;;ADzfI;EACI,8BAAA;AC4fR;;ADzfI;EACI,4BAAA;AC4fR;;ADzfI;EACI,+BAAA;AC4fR;;ADzfI;EACI,6BAAA;EACA,8BAAA;AC4fR;;ADzfI;EACI,4BAAA;EACA,+BAAA;AC4fR;;ADnhBI;EACI,6BAAA;ACshBR;;ADnhBI;EACI,8BAAA;ACshBR;;ADnhBI;EACI,4BAAA;ACshBR;;ADnhBI;EACI,+BAAA;ACshBR;;ADnhBI;EACI,6BAAA;EACA,8BAAA;ACshBR;;ADnhBI;EACI,4BAAA;EACA,+BAAA;ACshBR;;AD7iBI;EACI,6BAAA;ACgjBR;;AD7iBI;EACI,8BAAA;ACgjBR;;AD7iBI;EACI,4BAAA;ACgjBR;;AD7iBI;EACI,+BAAA;ACgjBR;;AD7iBI;EACI,6BAAA;EACA,8BAAA;ACgjBR;;AD7iBI;EACI,4BAAA;EACA,+BAAA;ACgjBR;;ADvkBI;EACI,6BAAA;AC0kBR;;ADvkBI;EACI,8BAAA;AC0kBR;;ADvkBI;EACI,4BAAA;AC0kBR;;ADvkBI;EACI,+BAAA;AC0kBR;;ADvkBI;EACI,6BAAA;EACA,8BAAA;AC0kBR;;ADvkBI;EACI,4BAAA;EACA,+BAAA;AC0kBR;;ADjmBI;EACI,6BAAA;AComBR;;ADjmBI;EACI,8BAAA;AComBR;;ADjmBI;EACI,4BAAA;AComBR;;ADjmBI;EACI,+BAAA;AComBR;;ADjmBI;EACI,6BAAA;EACA,8BAAA;AComBR;;ADjmBI;EACI,4BAAA;EACA,+BAAA;AComBR;;AD3nBI;EACI,6BAAA;AC8nBR;;AD3nBI;EACI,8BAAA;AC8nBR;;AD3nBI;EACI,4BAAA;AC8nBR;;AD3nBI;EACI,+BAAA;AC8nBR;;AD3nBI;EACI,6BAAA;EACA,8BAAA;AC8nBR;;AD3nBI;EACI,4BAAA;EACA,+BAAA;AC8nBR;;ADrpBI;EACI,6BAAA;ACwpBR;;ADrpBI;EACI,8BAAA;ACwpBR;;ADrpBI;EACI,4BAAA;ACwpBR;;ADrpBI;EACI,+BAAA;ACwpBR;;ADrpBI;EACI,6BAAA;EACA,8BAAA;ACwpBR;;ADrpBI;EACI,4BAAA;EACA,+BAAA;ACwpBR;;AD/qBI;EACI,6BAAA;ACkrBR;;AD/qBI;EACI,8BAAA;ACkrBR;;AD/qBI;EACI,4BAAA;ACkrBR;;AD/qBI;EACI,+BAAA;ACkrBR;;AD/qBI;EACI,6BAAA;EACA,8BAAA;ACkrBR;;AD/qBI;EACI,4BAAA;EACA,+BAAA;ACkrBR;;ADzsBI;EACI,6BAAA;AC4sBR;;ADzsBI;EACI,8BAAA;AC4sBR;;ADzsBI;EACI,4BAAA;AC4sBR;;ADzsBI;EACI,+BAAA;AC4sBR;;ADzsBI;EACI,6BAAA;EACA,8BAAA;AC4sBR;;ADzsBI;EACI,4BAAA;EACA,+BAAA;AC4sBR;;ADnuBI;EACI,6BAAA;ACsuBR;;ADnuBI;EACI,8BAAA;ACsuBR;;ADnuBI;EACI,4BAAA;ACsuBR;;ADnuBI;EACI,+BAAA;ACsuBR;;ADnuBI;EACI,6BAAA;EACA,8BAAA;ACsuBR;;ADnuBI;EACI,4BAAA;EACA,+BAAA;ACsuBR;;AD7vBI;EACI,6BAAA;ACgwBR;;AD7vBI;EACI,8BAAA;ACgwBR;;AD7vBI;EACI,4BAAA;ACgwBR;;AD7vBI;EACI,+BAAA;ACgwBR;;AD7vBI;EACI,6BAAA;EACA,8BAAA;ACgwBR;;AD7vBI;EACI,4BAAA;EACA,+BAAA;ACgwBR;;ADvxBI;EACI,6BAAA;AC0xBR;;ADvxBI;EACI,8BAAA;AC0xBR;;ADvxBI;EACI,4BAAA;AC0xBR;;ADvxBI;EACI,+BAAA;AC0xBR;;ADvxBI;EACI,6BAAA;EACA,8BAAA;AC0xBR;;ADvxBI;EACI,4BAAA;EACA,+BAAA;AC0xBR;;ADjzBI;EACI,6BAAA;ACozBR;;ADjzBI;EACI,8BAAA;ACozBR;;ADjzBI;EACI,4BAAA;ACozBR;;ADjzBI;EACI,+BAAA;ACozBR;;ADjzBI;EACI,6BAAA;EACA,8BAAA;ACozBR;;ADjzBI;EACI,4BAAA;EACA,+BAAA;ACozBR;;AD30BI;EACI,6BAAA;AC80BR;;AD30BI;EACI,8BAAA;AC80BR;;AD30BI;EACI,4BAAA;AC80BR;;AD30BI;EACI,+BAAA;AC80BR;;AD30BI;EACI,6BAAA;EACA,8BAAA;AC80BR;;AD30BI;EACI,4BAAA;EACA,+BAAA;AC80BR;;ADr2BI;EACI,6BAAA;ACw2BR;;ADr2BI;EACI,8BAAA;ACw2BR;;ADr2BI;EACI,4BAAA;ACw2BR;;ADr2BI;EACI,+BAAA;ACw2BR;;ADr2BI;EACI,6BAAA;EACA,8BAAA;ACw2BR;;ADr2BI;EACI,4BAAA;EACA,+BAAA;ACw2BR;;AD/3BI;EACI,6BAAA;ACk4BR;;AD/3BI;EACI,8BAAA;ACk4BR;;AD/3BI;EACI,4BAAA;ACk4BR;;AD/3BI;EACI,+BAAA;ACk4BR;;AD/3BI;EACI,6BAAA;EACA,8BAAA;ACk4BR;;AD/3BI;EACI,4BAAA;EACA,+BAAA;ACk4BR;;ADz5BI;EACI,6BAAA;AC45BR;;ADz5BI;EACI,8BAAA;AC45BR;;ADz5BI;EACI,4BAAA;AC45BR;;ADz5BI;EACI,+BAAA;AC45BR;;ADz5BI;EACI,6BAAA;EACA,8BAAA;AC45BR;;ADz5BI;EACI,4BAAA;EACA,+BAAA;AC45BR;;AA7gCA;EACE,kBAAA;EACA,WAAA;AAghCF;AA9gCE;;EAEE,gBAAA;EACA,mBAAA;ED4BA,oBAAA;EC1BA,kCAAA;EACA,cDTI;ACyhCR;AA7gCE;EACE,yCAAA;EACA,QAAA;AA+gCJ;AA5gCE;EACE,aAAA;AA8gCJ;AA1gCI;EDoBA,kBCnBoB;EDoBpB,MCpBoC;EDuBpC,OCvB8C;EAC5C,WAAA;EACA,sEAAA;EACA,WAAA;EACA,YAAA;EDTF,8BCUyB;EACvB,UAAA;AAghCN;AA7gCI;EACE,4BAAA;EDCF,mBAAA;ECCE,gBAAA;EACA,yBAAA;AA+gCN;AA1gCI;EDCA,kBAAA;EACA,oBCDoC;EDEpC,WCF6D;EAC3D,WAAA;EACA,sEAAA;EACA,WAAA;EACA,YAAA;EACA,UAAA;AA8gCN;AA5gCI;EACE,WAAA;AA8gCN;AA5gCI;EACE,2CAAA;AA8gCN;AA3gCI;EACE,cDzDE;ACskCR;AAzgCE;EACE,kBAAA;AA2gCJ;AAzgCI;EDtBA,kBCuBoB;EDtBpB,SCsBkD;EDrBlD,WCqBsC;EACpC,WAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;EACA,yBAAA;EACA,wBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;AA6gCN;AA1gCI;EACE,iBAAA;ED5DF,kBC6DyB;EACvB,iBAAA;EACA,mBAAA;EACA,2CAAA;AA8gCN;AA3gCI;EACE,aAAA;EACA,YAAA;AA6gCN;AA3gCM;EACE,aAAA;AA6gCR;AA1gCM;EACE,aAAA;AA4gCR;AAzgCM;EACE,gCAAA;EDhEJ,oBAAA;ECkEI,oCAAA;EACA,kBAAA;EAEA,oCAAA;AA0gCR;AAxgCQ;EACE,gCAAA;AA0gCV;AAvgCQ;EACE,aAAA;AAygCV;AAngCE;EACE,mBDpHI;EAiBJ,mBCoGuB;ED5EvB,kBC6EkB;ED5ElB,QC4E+C;EDzE/C,UCyEmC;EACnC,YAAA;EACA,WAAA;EACA,UAAA;AAygCJ;AAvgCI;EACE,WAAA;EACA,YAAA;EACA,gBAAA;ED7FF,mBAAA;EC+FE,eAAA;EACA,gBAAA;AAygCN;AArgCE;EDpHE,kBCsHuB;EACvB,mBDxII;ECyIJ,kBAAA;AAwgCJ;AArgCE;EAEE,mBD9II;EAiBJ,kBC8HuB;EACvB,YAAA;AAwgCJ;AArgCE;EACE,YAAA;EACA,oCAAA;AAugCJ;AAngCI;EDhHA,kBCiHoB;EDhHpB,SCgHkD;ED/GlD,WC+GsC;EACpC,WAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;EACA,yBAAA;EACA,wBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;AAugCN;AApgCI;EDrJA,kBCsJyB;EACvB,wBAAA;EACA,YAAA;AAwgCN;AArgCI;EACE,gBAAA;EACA,YAAA;EACA,WAAA;EACA,sBAAA;AAugCN;AArgCM;EACE,cAAA;EACA,YAAA;EACA,cDxLE;AC+rCV;AAlgCE;EACE,aAAA;AAogCJ;AA//BM;EACE,YAAA;EDhLJ,kBCiL2B;EACvB,wBAAA;AAmgCR;AAjgCQ;EACE,YAAA;AAmgCV;AAjgCU;EACE,aAAA;AAmgCZ;AAhgCU;ED3KN,mBAAA;AC8qCJ;AA//BU;EACE,wBAAA;AAigCZ;AA9/BU;EACE,cAAA;AAggCZ;AA7/BU;EACE,aAAA;AA+/BZ;AA5/BU;EACE,0BAAA;ED5LR,mBAAA;EC8LQ,eAAA;EACA,sBAAA;AA8/BZ;AA1/BQ;EACE,yBAAA;EACA,4BAAA;AA4/BV;AAt/BE;EDjOE,sDCkOoB;ED5NpB,8BC+NuB;AA0/B3B;AAv/BI;EDlOA,8BCoOyB;AA0/B7B;AAv/BI;EAKE,iBAAA;EACA,gBAAA;AAq/BN;AAh/BM;EACE,gBAAA;AAk/BR;AA9+BI;EDvOA,oBAAA;ECyOE,iBAAA;EACA,gBAAA;AAg/BN;AA5+BE;EACE,yBAAA;EACA,4CAAA;AA8+BJ;AA3+BE;EACE,gBAAA;EACA,kBAAA;EDrPA,oBAAA;EAhBA,kBCuQuB;EACvB,kCAAA;EACA,8BAAA;AA++BJ;AA7+BI;EDnPA,kBCoPoB;EDnPpB,SCmPkD;EDlPlD,WCkPsC;EACpC,WAAA;EACA,qBAAA;EACA,iCAAA;EACA,yBAAA;EAEA,6BAAA;EACA,WAAA;EACA,UAAA;AAg/BN;AA3+BI;EACE,6BAAA;AA6+BN;AA99BE;EACE,gCAAA;ED1SA,kBC2SuB;EACvB,4BAAA;EACA,gBAAA;AAk+BJ;AA/9BE;EACE,cDpUQ;EAmCR,oBAAA;ECmSA,iBAAA;ED3RA,kBC4RkB;ED1RlB,UC0RoC;EDzRpC,aCyRkD;AAm+BtD;AAh+BE;EACE,8BAAA;AAk+BJ;;AA99BA;EACE,4BAAA;AAi+BF;AA99BI;EDhTA,mBAAA;ECkTE,6CAAA;AAg+BN","sourcesContent":["// Color Variables\n$primary: #1E2E5F;\n$secondary: #BE2532;\n$black: #000000;\n$white: #ffffff;\n$grey: #808080;\n$red: #D9132E;\n$lightbg: #fbfbfb;\n$lightblue:#E9F1FD;\n\n\n/*--------------Mixins------------------*/\n@mixin box-shadow($shadow) {\n    -webkit-box-shadow: $shadow;\n    -moz-box-shadow: $shadow;\n    box-shadow: $shadow;\n}\n\n@mixin border-radius($radius: none) {\n    -webkit-border-radius: $radius;\n    -moz-border-radius: $radius;\n    border-radius: $radius;\n}\n\n@mixin appearance() {\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n}\n\n@function calculateRem($size) {\n    $remSize: $size / 16px;\n    @return #{$remSize}rem;\n}\n\n@mixin fontSize($size) {\n    //font-size: $size;\n    font-size: calculateRem($size);\n}\n\n@mixin position($position,\n    $top: null,\n    $right: null,\n    $bottom: null,\n    $left: null) {\n    position: $position;\n    top: $top;\n    right: $right;\n    bottom: $bottom;\n    left: $left;\n}\n\n@mixin abs-position ($top, $right, $bottom, $left) {\n    // @include abs-position(10px, 10px, auto, auto);\n    position: absolute;\n    top: $top;\n    right: $right;\n    bottom: $bottom;\n    left: $left;\n}\n\n// Margins\n@for $i from 0 to 20 {\n    .ml-#{$i} {\n        margin-left: 4px * $i !important;\n    }\n\n    .mr-#{$i} {\n        margin-right: 4px * $i !important;\n    }\n\n    .mt-#{$i} {\n        margin-top: 4px * $i !important;\n    }\n\n    .mb-#{$i} {\n        margin-bottom: 4px * $i !important;\n    }\n\n    .mx-#{$i} {\n        margin-left: 4px * $i !important;\n        margin-right: 4px * $i !important;\n    }\n\n    .my-#{$i} {\n        margin-top: 4px * $i !important;\n        margin-bottom: 4px * $i !important;\n    }\n}\n\n// Paddings\n@for $i from 0 to 20 {\n    .pl-#{$i} {\n        padding-left: 4px * $i !important;\n    }\n\n    .pr-#{$i} {\n        padding-right: 4px * $i !important;\n    }\n\n    .pt-#{$i} {\n        padding-top: 4px * $i !important;\n    }\n\n    .pb-#{$i} {\n        padding-bottom: 4px * $i !important;\n    }\n\n    .px-#{$i} {\n        padding-left: 4px * $i !important;\n        padding-right: 4px * $i !important;\n    }\n\n    .py-#{$i} {\n        padding-top: 4px * $i !important;\n        padding-bottom: 4px * $i !important;\n    }\n}","@import \"../../SCSS/Mixins.scss\";\n\n.inputField {\n  position: relative;\n  width: 100%;\n\n  label,\n  input {\n    font-weight: 400;\n    letter-spacing: 0px;\n    @include fontSize(13px);\n    font-family: \"Poppins\", sans-serif;\n    color: $black;\n  }\n\n  label {\n    transform: translate(14px, 10px) scale(1);\n    top: 3px;\n  }\n\n  svg {\n    display: none;\n  }\n\n  &.vehicleNumberField {\n    &:before {\n      @include position(absolute, $top: 0, $left: 0);\n      content: \"\";\n      background: url(\"./../../../public/images/ind.svg\") no-repeat 0 0 /30px;\n      width: 40px;\n      height: 44px;\n      @include border-radius(5px 0px 0px 5px);\n      z-index: 4;\n    }\n\n    input {\n      padding: 10px 12px 11px 42px;\n      @include fontSize(14px);\n      font-weight: 700;\n      text-transform: uppercase;\n    }\n  }\n\n  &.datepicker {\n    &:before {\n      @include position(absolute, $top: calc(50% - 6px), $right: 12px);\n      content: \"\";\n      background: url(\"./../../../public/images/calender_icon.svg\") no-repeat 0 0 /13px;\n      width: 13px;\n      height: 13px;\n      z-index: 4;\n    }\n    .MuiTextField-root {\n      width: 100%;\n    }\n    fieldset {\n      border-color: rgba(0, 0, 0, 0.2) !important;\n    }\n\n    label {\n      color: $black;\n    }\n  }\n\n  &.nativeSelect {\n    position: relative;\n\n    &:before {\n      @include position(absolute, $right: 10px, $top: 17px);\n      content: \"\";\n      border: solid $black;\n      border-width: 0px 0px 1.4px 1.4px;\n      transform: rotate(-45deg);\n      transition: all 0.3s ease;\n      transform-origin: center;\n      height: 6px;\n      width: 6px;\n      z-index: 1;\n    }\n\n    .MuiInputLabel-shrink {\n      background: white;\n      @include border-radius(8px);\n      padding-left: 4px;\n      padding-right: 12px;\n      transform: translate(8px, -9px) scale(0.75);\n    }\n\n    .MuiInputBase-root {\n      margin-top: 0;\n      height: 44px;\n\n      &:before {\n        display: none;\n      }\n\n      &:after {\n        display: none;\n      }\n\n      .MuiNativeSelect-select {\n        padding: 11.7px 24px 11.6px 10px;\n        @include fontSize(13px);\n        border: 1px solid rgba(0, 0, 0, 0.2);\n        border-radius: 8px;\n        // height: 44px;\n        font-family: \"poppins\", \"sans-serif\";\n\n        &:focus {\n          border-color: $primary !important;\n        }\n\n        :nth-child(1) {\n          display: none;\n        }\n      }\n    }\n  }\n\n  .infoMessage {\n    background: $white;\n    @include border-radius(20px);\n    @include position(absolute, $left: -7px, $top: 9px);\n    height: 16px;\n    width: 16px;\n    z-index: 9;\n\n    svg {\n      color: #000;\n      opacity: 0.6;\n      display: inherit;\n      @include fontSize(14px);\n      margin-top: 1px;\n      margin-left: 1px;\n    }\n  }\n\n  input {\n    // height: 20px;\n    @include border-radius(8px);\n    background: $white;\n    padding: 12px 12px;\n  }\n\n  .MuiInputBase-root {\n    // @include box-shadow(0px 3px 6px rgba($black, 0.1));\n    background: $white;\n    @include border-radius(8px);\n    height: 44px;\n  }\n\n  .MuiInputBase-multiline {\n    height: auto;\n    font-family: \"poppins\", \"sans-serif\";\n  }\n\n  .MuiAutocomplete-root {\n    &:before {\n      @include position(absolute, $right: 14px, $top: 17px);\n      content: \"\";\n      border: solid $black;\n      border-width: 0px 0px 1.4px 1.4px;\n      transform: rotate(-45deg);\n      transition: all 0.3s ease;\n      transform-origin: center;\n      height: 6px;\n      width: 6px;\n      z-index: 1;\n    }\n\n    .MuiAutocomplete-inputRoot {\n      @include border-radius(8px);\n      padding: 0px 0px 0px 8px;\n      height: 44px;\n    }\n\n    .MuiAutocomplete-clearIndicator {\n      background: #fff;\n      height: 18px;\n      width: 18px;\n      border: 1px solid #ccc;\n\n      svg {\n        display: block;\n        height: 12px;\n        color: $primary;\n      }\n    }\n  }\n\n  .MuiAutocomplete-endAdornment {\n    display: none;\n  }\n\n  .MuiAutocomplete-hasClearIcon {\n    .MuiFormControl-root {\n      .MuiOutlinedInput-root {\n        height: 44px;\n        @include border-radius(8px);\n        padding: 8px 0px 7px 8px;\n\n        .MuiButtonBase-root {\n          height: 20px;\n\n          &.MuiAutocomplete-clearIndicator {\n            display: none;\n          }\n\n          .MuiChip-label {\n            @include fontSize(10px);\n          }\n\n          &#ArrowDropDownIcon {\n            display: none !important;\n          }\n\n          svg {\n            display: block;\n          }\n\n          .MuiTouchRipple-root {\n            display: none;\n          }\n\n          .MuiChip-deleteIcon {\n            color: rgba(0, 0, 0, 0.26);\n            @include fontSize(18px);\n            cursor: pointer;\n            margin: 0px 2px 0 -6px;\n          }\n        }\n\n        .MuiAutocomplete-input {\n          min-width: 0px !important;\n          padding: 4.5px 4px 7.5px 5px;\n        }\n      }\n    }\n  }\n\n  .MuiAutocomplete-popper {\n    @include box-shadow(0px 4px 12px rgba(0, 0, 0, 0.2) !important);\n    // box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),\n    //   0px 8px 10px 1px rgba(0, 0, 0, 0.14), 0px 3px 14px 2px rgba(0, 0, 0, 0.12) !important;\n    @include border-radius(0px 0px 8px 8px);\n    // z-index: 999;\n\n    .MuiAutocomplete-paper {\n      // @include box-shadow(0px 4px 12px rgba(0, 0, 0, 0));\n      @include border-radius(0px 0px 8px 8px);\n    }\n\n    ul {\n      // @include box-shadow(0px 4px 12px rgba(0,0,0,0.2));\n      // box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),\n      //   0px 8px 10px 1px rgba(0, 0, 0, 0.14),\n      //   0px 3px 14px 2px rgba(0, 0, 0, 0.12);\n      max-height: 240px;\n      overflow-y: auto;\n\n\n\n      // z-index: 999;\n      li {\n        text-align: left\n      }\n    }\n\n    .MuiAutocomplete-option {\n      @include fontSize(13px);\n      line-height: 18px;\n      min-height: 32px;\n    }\n  }\n\n  .MuiInputLabel-shrink {\n    color: $primary !important;\n    transform: translate(14px, -9px) scale(0.75);\n  }\n\n  .MuiSelect-select {\n    text-align: left;\n    padding: 14px 12px;\n    @include fontSize(13px);\n    @include border-radius(8px);\n    font-family: \"Poppins\", sans-serif;\n    padding-right: 16px !important;\n\n    &:before {\n      @include position(absolute, $right: 10px, $top: 20px);\n      content: \"\";\n      border: solid $black;\n      border-width: 0px 0px 1.4px 1.4px;\n      transform: rotate(-45deg);\n      // transition: all 0.3s ease;\n      transform-origin: left center;\n      height: 6px;\n      width: 6px;\n    }\n  }\n\n  .Mui-focused {\n    .MuiOutlinedInput-notchedOutline {\n      border-color: #000 !important;\n    }\n\n    // .MuiSelect-select {\n    //   &:before {\n    //     // border: solid $primary;\n    //     border-width: 0px 0px 1.4px 1.4px;\n    //     // transform: rotate(-223deg);\n    //     right: 10px;\n    //     // transform-origin: top center;\n    //     top: 19px;\n    //   }\n    // }\n  }\n\n  fieldset {\n    border-color: rgba(0, 0, 0, 0.2);\n    @include border-radius(8px);\n    border-width: 1px !important;\n    font-weight: 500;\n  }\n\n  .error {\n    color: $secondary;\n    @include fontSize(11px);\n    text-align: right;\n    @include position(absolute, $right: 0px, $bottom: -16px);\n  }\n\n  .MuiAutocomplete-hasPopupIcon.MuiAutocomplete-hasClearIcon.css-1h51icj-MuiAutocomplete-root .MuiOutlinedInput-root {\n    padding-right: 40px !important;\n  }\n}\n\n.MuiMenu-paper {\n  max-height: 200px !important;\n\n  .MuiMenu-list {\n    .MuiMenuItem-root {\n      @include fontSize(14px);\n      font-family: \"Poppins\", sans-serif !important;\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
